import { ExternalFile, config } from "@tracabois/domain"

export const externalFileUrl = (file?: ExternalFile): string => {
    const encodedPath = file?.path ? encodeURI(file?.path) : undefined
    return encodedPath ? `${config.baseUrl}/file/${encodedPath}` : ''
}
